import { Currency, supportedTokens } from '@/constants';

import { checkSupportedPair } from './checkSupportedPair';

const currencies = Object.values(Currency);

const tokenRegExp = new RegExp(`(?:^|/)(?:(${currencies.join('|')})(?:-(${currencies.join('|')}))?)(?=/|$)`, 'i');

export const findTokenCombinationFromUrl = (pathname: string): (Currency | undefined)[] => {
  let matchedL1FirstToken = undefined;
  let matchedL1SecondToken = undefined;
  const match = pathname.match(tokenRegExp);

  if (match) {
    const [, fromTokenString, toTokenString] = match;

    const fromToken =
      fromTokenString && (supportedTokens as string[]).includes(fromTokenString.toUpperCase())
        ? Currency[fromTokenString.toUpperCase() as Currency]
        : undefined;

    const toToken =
      toTokenString && (supportedTokens as string[]).includes(toTokenString.toUpperCase())
        ? Currency[toTokenString.toUpperCase() as Currency]
        : undefined;

    if (!fromToken || !toToken) {
      if (!fromToken && !toToken) {
        return [undefined, undefined];
      } else if (!fromToken) {
        matchedL1FirstToken = undefined;
        matchedL1SecondToken = toToken;
      } else if (!toToken) {
        matchedL1FirstToken = fromToken;
        matchedL1SecondToken = undefined;
      }
      return [matchedL1FirstToken, matchedL1SecondToken];
    }

    const isSameToken = fromToken === toToken;
    const isInvalidCombination = !checkSupportedPair(fromToken, toToken);

    if (!isSameToken && !isInvalidCombination) {
      if (fromToken) matchedL1FirstToken = fromToken;
      if (toToken) matchedL1SecondToken = toToken;
    }
  }

  return [matchedL1FirstToken, matchedL1SecondToken];
};
